import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService, SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';
import { CalendarTranslateService } from '../../../modules/UIKit/services/calendarTranslate.service';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { ComponentCanDeactivate } from '../../../services/utils/pending-changes.guard';

@Component({
  selector: 'app-newcampaign',
  //templateUrl: './newcampaign.component.html',
  templateUrl: './changecampaign.component.html',
  //styleUrls: ['./newcampaign.component.css'],
  styleUrls: ['./changecampaign.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [CampaignService]
})
export class NewcampaignComponent implements OnInit, ComponentCanDeactivate {
  campaignName: any;

  @ViewChild('campaignNameForm') campaignNameForm: ElementRef
  @ViewChild('formSubmission') formSubmission: ElementRef
  @ViewChild('settingsFormSubmission') settingsFormSubmission: ElementRef
  @ViewChild('budgetFormSubmission') budgetFormSubmission: ElementRef
  @ViewChild('campNm') campNm: ElementRef

  canDeactivate(): Observable<boolean> | boolean {
   // insert logic to check if there are pending changes here;
   // returning true will navigate without confirmation
   // returning false will show a confirm alert before navigating away
   return true;
 }

 // @HostListener allows us to also guard against browser refresh, close, etc.
@HostListener('window:beforeunload', ['$event'])
unloadNotification($event: any) {
  if (!this.canDeactivate()) {
      $event.returnValue = 'This message is displayed to the user in IE and Edge when they navigate without using Angular routing (type another URL/close the browser/etc)';
  }
}

  public type: string;
  private sub: any;
  @ViewChild('steps') steps: ElementRef;

  public result: any[] = [];
  public masterResult: any[];
  public channelResult: any[];
  public budgetResult: any[];
  public campaignTypeModel: any[];
  public campaignPriorityModel: any[];
  public bypassCustomerRulesModel: any[];


  private stepsItems: MenuItem[];
  types: SelectItem[];
  priorityTypes: SelectItem[];
  showBudgetError: number;
  showBudgetRangeError: number = 0;
  showBudgetPuntiError: number = 0;
  showBudgetPercentualeError: number = 0;
  showBudgetValoreError: number = 0;

  activeIndex = 0;
  selectbuttonStyleClass = 'goal-type-button ui-buttonset-4';
  campaignStepsStyleClass = 'campaign-steps';
  campaignEachGoal = 'campaign-each-goal';
  priority: number;
  priorityNum: number;
  goalEnabledIndex : number;
  goalNextButtonDisabled: boolean = true;
  selectedGoalId: number;
  campaignPriorityCode: string;
  channelCode: number;
  flagOnlyCardHolder: boolean;
  flagOnlyLoyaltyCard: boolean;
  budgetErrorValore: string;
  budgetErrorPercentuale: string;
  budgetErrorPunti: string;
  budgetRangeErrorText: string;

  public campaignTypeCode = 0;
  flagCustomerPressureRule: number;
  campaigndata = {};
  selectedChannels: number;
  isRedemptionPeriodOpen: boolean;
  couponsCanBeOnlyBeRedeemedByCardHolders: number;
  couponsCanBeOnlyBeRedeemedIfLoyaltyCardIsUsed: number;
  percentageDiscount: number;
  monetaryAmount: number;
  loyaltyPoints: number;
  budgetAmountArr1: number;
  budgetAmountArr2: number;
  budgetAmountArr3: number;
  sum: number = 0;
  emissionEndDate: any;
  redemptionStartDate: any;
  redemptionEndDate: any;
  redemptionDuration: number;
  emissionDuration: number;
  budgetObject: {};
  selectedDate: Date;
  sliderDisabled: boolean = true;
  checkPercentageDiscount: number;
  checkMonetaryAmount: number;
  checkLoyaltyPoints: number;
  budget: any;
  totalBudget: number = 0;
  scontoValoreSliderVal: number = 0;
  scontoPercentualeSliderVal: number = 0;
  extraPuntiSliderVal: number = 0;
  budgetError: number = 0;
  isBackFromBudget: boolean= false;
  scontoValoreBudgetError: number = 0;
  scontoPercentualeBudgetError: number = 0;
  extraPuntiBudgetError: number = 0;
  description: string[] = [];

  /*variables for change campaign starts*/
  goalType = 0;
  activityType = 100;
  selectedActivity = [];
  selectedValues: string[] = [];
  budgetErrorText: string;
  rangeSliderDivision: number[] = [];
  rangeSliderClasses: string[] = [];
  saveEvent: string = '';
  /*variables for change campaign ends*/


  constructor(
    private campaignService: CampaignService,
    private route: ActivatedRoute,
    private router: Router,
    private srvNotify: MessageService,
    private translate: TranslateService,
    private srvCalTranslate: CalendarTranslateService
  ) {
    this.showBudgetError = 0;
    this.rangeSliderDivision = [0, 25, 50, 75, 100];
    this.rangeSliderClasses = ['text-left', 'text-left', 'text-center', 'text-right', 'text-right'];
    this.sub = this.route.params.subscribe(params => {
      this.type = params['type'];
        if (this.type != undefined && this.result == undefined && (this.type == 'budget' || this.type == 'master' || this.type == 'channel')) {
          this.router.navigate(['/newcampaign', 'goal']);
        }
    });
    this.translate.get(
      [        'campaign'      ]
    ).subscribe((res) => {
      this.stepsItems = [
        {          label: res.campaign.step1        },
        {          label: res.campaign.step2        },
        {          label: res.campaign.step3        },
        {          label: res.campaign.step4        }
      ];
      this.description = [
        res.campaign.stepDesc1,
        res.campaign.stepDesc2,
        res.campaign.stepDesc3,
        res.campaign.stepDesc4
      ];
    });
  }

  activityChoose(selActivity, e){
    this.selectedGoalId = selActivity.targetCode;
  }

  ngOnInit() {
    this.priorityNum = 0;
    this.priorityTypes = [];
    this.types = [];
    this.sub = this.route.params.subscribe(params => {
      this.type = params['type'];
      if (this.type == undefined || this.type == 'goal') {
        this.type = 'goal';
        this.activeIndex = 0;
      } else if (this.type == 'master' && !this.isBackFromBudget) {
          this.activeIndex = 1;
          this.campaignService.getCreateCampaignDefaultFormData(this.selectedGoalId).subscribe(res => {
            this.campaignTypeCode = res.campaignMasterPrefillModel.type;
            this.flagCustomerPressureRule = res.campaignMasterPrefillModel.bypass;
            this.campaignPriorityCode = res.campaignMasterPrefillModel.priority;
            this.campaignPriorityCode = res.campaignMasterPrefillModel.priority;
            this.campaignPriorityCode = res.campaignMasterPrefillModel.priority;
            this.selectedChannels = res.campaignChannelPrefillModel.channel;
            if (res.campaignChannelPrefillModel.isRedemptionPeriodOpen == '1')
              this.isRedemptionPeriodOpen = true;
            if (res.campaignChannelPrefillModel.flagOnlyCardHolder == '1')
              this.flagOnlyCardHolder = true;
            if (res.campaignChannelPrefillModel.flagOnlyLoyaltyCard == '1')
              this.flagOnlyLoyaltyCard = true;
            this.emissionDuration = res.campaignChannelPrefillModel.emissionDuration;
            this.redemptionDuration = res.campaignChannelPrefillModel.redemptionDuration;
            this.checkPercentageDiscount = res.campaignBudgetConditionCheckModel.checkPercentageDiscount;
            this.checkMonetaryAmount = res.campaignBudgetConditionCheckModel.checkMonetaryAmount;
            this.checkLoyaltyPoints = res.campaignBudgetConditionCheckModel.checkLoyaltyPoints;
            this.budgetResult = [...this.budgetResult];
            if (this.budgetResult != undefined){
              this.budgetResult[0]['amount'] = res.campaignBudgetPrefilModel.percentageDiscount;
              this.budgetResult[1]['amount'] = res.campaignBudgetPrefilModel.monetaryAmount;
              this.budgetResult[2]['amount'] = res.campaignBudgetPrefilModel.loyaltyPoints;
              this.budgetResult[0]['min'] = 0;
              this.budgetResult[1]['min'] = 0;
              this.budgetResult[2]['min'] = 0;
            }

        });
      } else if (this.type == 'channel') {
        this.activeIndex = 2;

      } else if (this.type == 'budget') {
        this.activeIndex = 3;

      }
    });
    this.campaignService.getCreateCampaignFormData().subscribe(res => {
      for (let goal in res.campaignGoalModel) {
          this.types.push({ label: res.campaignGoalModel[goal].focusName, value: res.campaignGoalModel[goal].focusId });
      }
      let objs = Object.keys(res.campaignGoalModel).map(key => res.campaignGoalModel[key]);
      this.result = objs;
      this.masterResult = res.campaignMasterModel;
      this.campaignTypeModel = this.masterResult['campaignTypeModel'];
      this.campaignPriorityModel = this.masterResult['campaignPriorityModel'];
      this.bypassCustomerRulesModel = this.masterResult['bypassCustomerRulesModel'];
      this.channelResult = res.channelModel;
      this.budgetResult = res.budgetModel;
      for (let i = 0; i < this.campaignPriorityModel.length; i++){
        this.priorityTypes.push({label: this.campaignPriorityModel[i]['name'], value: this.campaignPriorityModel[i]['value']});
      }
    });
  }

  previousCampaignStep(){
    if (this.type == 'master'){
      this.isBackFromBudget = false;
      this.router.navigate(['/newcampaign', 'goal']);
    }
    if (this.type == 'budget'){
      this.isBackFromBudget = true;
      this.router.navigate(['/newcampaign', 'master']);
    }
  }

  nextCampaignStep(origin){
    if (this.activityType != 100){
      if (this.type == 'goal' && origin != 'save'){
        this.formSubmission.nativeElement.click();
        return false;
      }
      if (this.type == 'master' && origin != 'save'){
        this.settingsFormSubmission.nativeElement.click();
        return false;
      }
      if (this.type == 'budget' && origin == 'save'){
        this.saveEvent = 'saveExit';
        this.formSubmission.nativeElement.click();
        this.budgetFormSubmission.nativeElement.click();
        return false;
      }
    }
  }

  public priorityCheck(event) {
    if (parseInt(event) > 33.3 || parseInt(event) < 66.6) {
      this.priorityNum = 2;
    }
    if (parseInt(event) < 33.3) {
      this.priorityNum = 1;
    }
    if (parseInt(event) > 66.6) {
      this.priorityNum = 3;
    }
  }

  setEmissionEndDate(selectedVal: Date){
     var dat = new Date(selectedVal);
     dat.setDate(dat.getDate() + parseInt(<any>this.emissionDuration));
     this.emissionEndDate = (dat.getMonth() + 1) + '/' + dat.getDate() + '/' + dat.getFullYear();
     this.redemptionStartDate = selectedVal;
     this.setRedemptionEndDate(selectedVal);
  }

  setRedemptionEndDate(selectedRVal: Date){
    var datR = new Date(selectedRVal);
    datR.setDate(datR.getDate() + parseInt(<any>this.redemptionDuration));
    this.redemptionEndDate = (datR.getMonth() + 1) + '/' + datR.getDate() + '/' + datR.getFullYear();
  }

  campaignOnGoalSubmit(campaignGoalCreation) {
    campaignGoalCreation.businessGoalCode = this.selectedGoalId;
    this.campaigndata = Object.assign(this.campaigndata, campaignGoalCreation);
    if (this.saveEvent != 'saveExit'){
      this.type = 'master';
      this.router.navigate(['/newcampaign', 'master']);
    }
  }

  campaignOnMasterSubmit(settingsForm) {
    settingsForm.emissionStartDate = this.customDateFormat(settingsForm.emissionStartDate);
    settingsForm.emissionEndDate = this.customDateFormat(this.emissionEndDate);
    settingsForm.redemptionStartDate = this.customDateFormat(settingsForm.redemptionStartDate);
    settingsForm.redemptionEndDate = this.customDateFormat(this.redemptionEndDate);
    if (settingsForm.flagOnlyCardHolder == undefined || !settingsForm.flagOnlyCardHolder)
      settingsForm.flagOnlyCardHolder = '0';
    else
      settingsForm.flagOnlyCardHolder = '1';
    if (settingsForm.flagOnlyLoyaltyCard == undefined || !settingsForm.flagOnlyLoyaltyCard)
      settingsForm.flagOnlyLoyaltyCard = '0';
    else
      settingsForm.flagOnlyLoyaltyCard = '1';
    if (settingsForm.flagOpenRedemptionPeriod == undefined || !settingsForm.flagOpenRedemptionPeriod)
      settingsForm.flagOpenRedemptionPeriod = '0';
    else
      settingsForm.flagOpenRedemptionPeriod = '1';
    this.campaigndata = Object.assign(this.campaigndata, settingsForm);
    console.log(this.campaigndata);
    this.router.navigate(['/newcampaign', 'budget']);
    this.activeIndex = 2;
  }

  customDateFormat(date: any) {
    let d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    let year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
       day = '0' + day;
    }
    return day + '/' + month + '/' + year;
  }

  campaignOnBudgetSubmit(budgetForm) {
    this.sum = 0;
    for (let i = 0; i < this.budgetResult.length; i++){
      this.sum = this.sum + parseInt(this.budgetResult[i].amount);
    }
    if (this.sum > 100 || this.sum < 100){
      this.showBudgetRangeError = 1;
      this.budgetRangeErrorText = 'The sum of three percentage should always be 100';
    }else{
      this.budgetFormValidation(0, budgetForm.budgetAmountArr_0);
      this.budgetFormValidation(1, budgetForm.budgetAmountArr_1);
      this.budgetFormValidation(2, budgetForm.budgetAmountArr_2);
      this.showBudgetRangeError = 0;
      if (this.totalBudget === 1) {
        this.showBudgetError = 1;
        this.budgetErrorText = 'Budget cost must be grater than ' + this.totalBudget;
      }else {
        this.showBudgetError = 0;
      }
      if (this.budgetError === 0 && this.scontoValoreBudgetError === 0 && this.scontoPercentualeBudgetError === 0 && this.extraPuntiBudgetError === 0) {
        this.budgetObject = {
          'budget': budgetForm.budget,
          'notes': budgetForm.notes,
          'budgetInModel':
          {
            'prcLoyaltyId': '3',
            'prcLoyaltyPoints': budgetForm.budgetAmountArr_2,
            'prcMonetoryDiscount': budgetForm.budgetAmountArr_0,
            'prcMonetoryId': '1',
            'prcPercentageDiscount': budgetForm.budgetAmountArr_1,
            'prcPercentageId': '2'
          }
        };
        this.campaigndata = Object.assign(this.campaigndata, this.budgetObject);
        console.log(JSON.stringify(this.campaigndata));
        this.campaignService.campaignCreation(this.campaigndata).subscribe(res => {
          this.router.navigateByUrl('/campaignlist');
        });
      }
    }
  }

  public resetGoalIndex(){
    this.goalEnabledIndex = 10;
    this.goalNextButtonDisabled = true;
  }

  setMinimumPercentage(event){
    this.totalBudget = 0;
    this.totalBudget = parseFloat(<any>this.checkPercentageDiscount) + parseFloat(<any>this.checkMonetaryAmount) + parseFloat(<any>this.checkLoyaltyPoints);
    if (parseInt(event.target.value) <= parseInt(<any>this.totalBudget)) {
      this.showBudgetError = 1;
      this.budgetErrorText = 'Budget cost must be grater than ' + this.totalBudget;
      this.budgetError = 1;
    }else{
      this.budgetError = 0;
      this.showBudgetError = 0;
    }
    if (this.budgetResult != undefined){
      this.budgetResult[0]['min'] = Math.round((100 / parseFloat(event.target.value)) * parseFloat(<any>this.checkPercentageDiscount));
      this.budgetResult[1]['min'] = Math.round((100 / parseFloat(event.target.value)) * parseFloat(<any>this.checkMonetaryAmount));
      this.budgetResult[2]['min'] = Math.round((100 / parseFloat(event.target.value)) * parseFloat(<any>this.checkLoyaltyPoints));
      this.budgetResult[0]['amount'] = Math.round((100 / parseFloat(event.target.value)) * parseFloat(<any>this.checkPercentageDiscount));
      this.budgetResult[1]['amount'] = Math.round((100 / parseFloat(event.target.value)) * parseFloat(<any>this.checkMonetaryAmount));
      this.budgetResult[2]['amount'] = Math.round((100 / parseFloat(event.target.value)) * parseFloat(<any>this.checkLoyaltyPoints));
      let eachDiff = (100 - this.budgetResult[0]['min']) / 4;
      let sum = this.budgetResult[0]['min'];
      this.rangeSliderDivision = [];
      this.rangeSliderDivision.push(Math.round(sum));
      for (let i = 0; i < 4; i++){
        sum = sum + eachDiff;
        this.rangeSliderDivision.push(Math.round(sum));
      }

    }
  }

  handleChange(index, e) {
    this.sum = 0;
    for (let i = 0; i < this.budgetResult.length; i++){
      this.sum = this.sum + parseInt(this.budgetResult[i].amount);
    }
    this.budgetFormValidation(index, e.value);
  }

  budgetFormValidation(index, val){
    if (index == 0){
      this.scontoValoreSliderVal = (parseFloat(this.budget) / 100) * parseInt(val);
      if (parseFloat(<any>this.scontoValoreSliderVal) < parseFloat(<any>this.checkPercentageDiscount)){
        this.scontoValoreBudgetError = 1;
        this.showBudgetValoreError = 1;
        this.budgetErrorValore = 'Sconto a valore Min value is ' + this.checkPercentageDiscount;
      }else{
        this.scontoValoreBudgetError = 0;
        this.showBudgetValoreError = 0;
      }
    }
    if (index == 1){
      this.scontoPercentualeSliderVal = (parseFloat(this.budget) / 100) * parseInt(val);
      if (parseFloat(<any>this.scontoPercentualeSliderVal) < parseFloat(<any>this.checkMonetaryAmount)){
        this.scontoPercentualeBudgetError = 1;
        this.showBudgetPercentualeError = 1;
        this.budgetErrorPercentuale = 'Sconto in percentuale Min value is ' + this.checkMonetaryAmount;
      }else{
        this.scontoPercentualeBudgetError = 0;
        this.showBudgetPercentualeError = 0;
      }
    }
    if (index == 2){
      this.extraPuntiSliderVal = (parseFloat(this.budget) / 100) * parseInt(val);
      if (parseFloat(<any>this.extraPuntiSliderVal) < parseFloat(<any>this.checkLoyaltyPoints)){
        this.extraPuntiBudgetError = 1;
        this.showBudgetPuntiError = 1;
        this.budgetErrorPunti = 'Extra punti Min value is ' + this.checkLoyaltyPoints;
      }else{
        this.showBudgetPuntiError = 0;
        this.extraPuntiBudgetError = 0;
      }
    }
  }

  ngAfterViewInit() {
    this.campNm.nativeElement.focus();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/newcampaign/newcampaign.component.ts